<template lang="pug">
    div
        Button(type="primary" @click="isModal = true" icon="md-more" )
        Modal(v-model="isModal" :title="title" @on-cancel='cancel' footer-hide=true width="80")
            Form(style="width:20" :model="value")
                Row(v-for="(item) in data.filter((e)=>e.type!='object')" :key="item.id")
                    Col(span="24")
                        FormItem(:label='$t("backendsTitle."+item.id)' :label-width="150")
                            component(:is="item.type" :value="item.value" :disabled="item.disabled" :min="0" :max="item.max" :step="item.step" @[item.fun]="changeData(item,$event)")
                                Option(v-if="item.type === 'Select' " v-for="(i) in item.options" :value="i.value" :key="i.value") {{ i.label }}
                Row
                    Col(span="24")
                        Alert(type="warning" refs="message" id="message")
                            span 
                                b {{$t("backendsTitle.isGlobalScope")}}
                            span {{$t("backendsTitle.openIsGlobalScope")}}
                            br
                            span 
                                b {{$t("backendsTitle.isGlobalScope")}}
                            span {{$t("backendsTitle.closeIsGlobalScope")}}
                            br
                            span 
                                Icon(type="md-checkmark-circle-outline") 
                            span :{{$t("backendsTitle.iconCheckmark")}},
                                b {{$t("backendsTitle.resetDefaultBtn")}}
                            span {{$t("backendsTitle.checkmarkTwo")}}
                            br
                            span
                                Icon(type="md-close") 
                            span :{{$t("backendsTitle.iconClose")}}
                Row
                    Col(span="24")
                        Content()
                            Layout
                                Sider(hide-trigger :style="{background: '#fff',maxHeight: '600px',overflow: 'auto'}" )
                                    Menu(theme="light" width="200px" @on-select='selectMenu' :active-name="currentTab")
                                        template(v-for="(item,index) in tabColumns")
                                            MenuItem(:name="item.groupName")
                                                Icon(:type="item.icon") 
                                                span(v-text="item.groupName") 
                                Content(:style="{padding: '10px', background: '#fff' ,maxHeight: '500px' ,overflow: 'auto'}")
                                    template(v-for="(actionName) in Object.keys(selectTab).filter((e)=>typeof selectTab[e] != 'string')")
                                        Row
                                            p {{ actionName }}
                                        Row(type="flex" justify="end")
                                            Button(type="primary" @click="originalSetting(selectTab.groupName)" 
                                            v-if="(selectTab.groupName !='all' && selectTab.icon!='md-close' && !isTabsDisable)"
                                            :disabled="!value['isPurchase'] || !(selectTab.groupName !='all' && selectTab.icon!='md-close' && !isTabsDisable)" 
                                            style="margin-right: 5px;"
                                            ) {{$t("backendsTitle.resetDefaultBtn")}}
                                            //- Button(type="primary" @click="addData(selectTab.groupName,actionName)"  :disabled="!value['isPurchase']"  v-show = "actionName == 'dnsProviderList'" ) Add
                                        Row
                                            Col(span="24" )
                                                Table.table(
                                                    ref="xTable"
                                                    :key="tabKey"
                                                    :class="tableHeaderStyle" 
                                                    :border="withBorder" 
                                                    style="margin-top: 8px;margin-bottom: 8px;text-overflow: ellipsis" 
                                                    :loading="isTableLoading" 
                                                    :size="tableSize" 
                                                    :columns="selectTab[actionName]"
                                                    :data="tabData.find((e)=>e.groupName == selectTab.groupName)[actionName]")
                                                    template(slot-scope="{row,index}" slot="action")
                                                        Button(icon="md-trash" shape="circle" :disabled="index<option[title][actionName].length" @click="deleteData(selectTab.groupName,index)")
            Row(type="flex" justify="end")
                Button(type="primary"  @click="ok"  :disabled="!value['isPurchase']") OK
        
    </template>
<script>
import FormSelect from "./Select/index.js";
export default {
    components: {
        FormSelect,
    },
    props: ["value", "title", "option"],
    data() {
        return {
            isModal: false,
            tabKey: 0,
            isTableLoading: false,
            tableSize: "default",
            data: [],
            rmFiles: [
                "isPurchase",
                "isShown",
                "name",
                "type",
                "formRender",
                "id",
                "value",
                "validityExtend",
                "price",
                "discount",
                "rmFornt",
            ],
            notCanEditFiles: ["validityStart", "validityEnd"],
            currentTab: "",
            tabColumns: [],
            tabData: [],
            changeGroup: ["all"],
            changeField: [],
            isTabsDisable: false,
            selectTab: {},
        };
    },
    computed: {
        tableHeaderStyle() {
            return this.$store.getters.getTableConfig.headerStyle;
        },
        withBorder() {
            return this.$store.getters.getTableConfig.withBorder;
        },
        isGlobalScope() {
            return !this.data.find((e) => e.id == "isGlobalScope").value;
        },
    },
    watch: {},
    methods: {
        setCurrentTab() {
            let currentTab = this.$store.state.queryGroupName;
            if (currentTab == "all") {
                currentTab = this.$store.getters.inGroupNames.filter((groupName) => groupName != "all")[0];
            }
            this.currentTab = currentTab;
        },
        async setTables() {
            let objKeys = Object.keys(this.value);
            this.data = objKeys
                .map((e) => {
                    let obj = {};
                    if (this.rmFiles.includes(e)) {
                        return obj;
                    } else if (typeof this.value[e] == "boolean") {
                        obj["type"] = "i-switch";
                        obj["fun"] = "on-change";
                    } else if (typeof this.value[e] == "string") {
                        obj["type"] = "Input";
                        obj["fun"] = "on-blur";
                    } else if (typeof this.value[e] == "number") {
                        obj["type"] = "InputNumber";
                        obj["fun"] = "on-change";
                    } else if (typeof this.value[e] == "object") {
                        obj["type"] = "object";
                        let groupNames = this.$store.getters.inGroupNames;
                        this.tabData = groupNames.map((groupName) => {
                            // 取得群組的groupScope
                            let findObjGroup = this.value[e].find((item) => item.groupName == groupName);
                            // 取得all的groupScope
                            const findAllObjGroup = this.value[e].find((item) => item.groupName == "all");
                            // 群組沒有設定,all有設定就會依照all的設定做顯示
                            if (!findObjGroup && findAllObjGroup) {
                                const defaultAllObjGroup = JSON.parse(
                                    JSON.stringify(Object.assign({}, findAllObjGroup, { groupName: groupName }))
                                );
                                return defaultAllObjGroup;
                            }
                            // 取得修改類別的option
                            let objKeys = Object.keys(this.option[this.title]);
                            // 若沒有直接建立
                            if (!findObjGroup) {
                                findObjGroup = {
                                    groupName: groupName,
                                };
                                // 這邊要注意 Changing single object in JS array changes all elements
                                objKeys.forEach((keyItem) => {
                                    findObjGroup[keyItem] = JSON.parse(
                                        JSON.stringify(this.option[this.title][keyItem])
                                    );
                                });
                            }
                            return findObjGroup;
                        });

                        this.setColumns();
                    }
                    obj["id"] = e;
                    obj["value"] = this.value[e];
                    obj["disabled"] = !this.value["isPurchase"];
                    if (this.notCanEditFiles.includes(e)) {
                        obj["disabled"] = true;
                    }
                    return obj;
                })
                .filter((e) => e.id);

            // 設定是否開放其他群組設定
            if (this.value.isGlobalScope) {
                this.currentTab = "all";
                this.isTabsDisable = true;
            }
        },
        setColumns() {
            this.tabColumns = this.tabData.map((tabItem, tabIndex) => {
                let objKeys = Object.keys(tabItem);
                let rtnObjKey = {};
                objKeys.forEach((key, index) => {
                    if (typeof tabItem[key] == "string") {
                        rtnObjKey[key] = tabItem[key];
                        rtnObjKey["icon"] = "md-close";
                        if (this.value.groupScope.find((e) => e.groupName == tabItem[key])) {
                            rtnObjKey["icon"] = "md-checkmark-circle-outline";
                        }
                    } else {
                        tabItem[key].forEach((item) => {
                            let rtnArr = [];
                            let tableFiles = Object.keys(item).filter((fieldItem) => !this.rmFiles.includes(fieldItem));
                            tableFiles.forEach((fieldItem) => {
                                const isAutoWidth = ["wafSetting", "isEnabledIntelligentProtection"].includes(this.title);
                                let width = isAutoWidth ? null : 120;
                                // 設定欄位寬度
                                if (fieldItem == "defaultRecordLine" || fieldItem == "dnsprovider") {
                                    width = 160;
                                } else if (fieldItem == "minTtl") {
                                    width = 100;
                                }
                                let render;

                                // 將dnsProviderList欄位註解，不讓admin做異動
                                if (fieldItem == "dnsprovider" || fieldItem == "minTtl") {
                                } else if (typeof item[fieldItem] == "boolean") {
                                    render = (h, params) => {
                                        if (this.isTabsDisable) {
                                            if (tabItem.groupName == "all") {
                                                params.disabled = false;
                                            } else {
                                                params.disabled = true;
                                            }
                                        } else if (key == "dnsProviderList" && params.column.key == "isEnabled") {
                                            params.disabled = true;
                                        } else {
                                            params.disabled = false;
                                        }
                                        return renderSwitch(key, tabIndex, h, params, this, this.dependencyCheck);
                                    };
                                } else if (typeof item[fieldItem] == "number") {
                                    render = (h, params) => {
                                        if (this.isTabsDisable) {
                                            if (tabItem.groupName == "all") {
                                                params.disabled = false;
                                            } else {
                                                params.disabled = true;
                                            }
                                        } else {
                                            params.disabled = false;
                                        }
                                        return renderNumberInput(key, tabIndex, h, params, this);
                                    };
                                } else if (
                                    fieldItem == "dnsRootDomain" ||
                                    fieldItem == "accessKeyId" ||
                                    fieldItem == "secretAccessKey"
                                ) {
                                    // render = (h, params) => {
                                    //     if (this.isTabsDisable) {
                                    //         if (tabItem.groupName == "all") {
                                    //             params.disabled = false;
                                    //         } else {
                                    //             params.disabled = true;
                                    //         }
                                    //     } else {
                                    //         params.disabled = false;
                                    //     }
                                    //     return renderInput(key, tabIndex, h, params, this);
                                    // };
                                    width = 300;
                                } else if (fieldItem == "dnsprovider") {
                                    render = (h, params) => {
                                        // if (this.isTabsDisable) {
                                        //     if (tabItem.groupName == "all") {
                                        //         params.disabled = false;
                                        //     } else {
                                        //         params.disabled = true;
                                        //     }
                                        // } else {
                                        //     params.disabled = false;
                                        // }
                                        return renderSelect(key, tabIndex, h, params, this);
                                    };
                                }
                                let isShowSuffix = [
                                    {
                                        key: "dnsProviderList",
                                        suffix: "CNAME Info",
                                    },
                                ];
                                const customLabelFields = {
                                    label: (key) => `${key}Label`,
                                    isShow: (key, vm, fieldItem) =>
                                        vm.title === "isEnabledIntelligentProtection"
                                            ? `${vm.title}${fieldItem.charAt(0).toUpperCase() + fieldItem.slice(1)}`
                                            : null,
                                    isEnabled: (key, vm, fieldItem) =>
                                        vm.title === "isEnabledIntelligentProtection"
                                            ? `${vm.title}${fieldItem.charAt(0).toUpperCase() + fieldItem.slice(1)}`
                                            : null,
                                };
                                const getFieldItemTitle = (fieldItem, key) => {
                                    const matchedSuffixItem =
                                        fieldItem === "isShow" && isShowSuffix.find((obj) => obj.key === key);
                                    if (matchedSuffixItem) {
                                        return this.$t(`backendsTitle.isShow`) + " " + matchedSuffixItem.suffix;
                                    }
                                    const useCustomLabel = customLabelFields[fieldItem];
                                    const label = useCustomLabel
                                        ? useCustomLabel(key, this, fieldItem) || fieldItem
                                        : fieldItem;
                                    return this.$t(`backendsTitle.${label}`);
                                };
                                rtnArr.push({
                                    key: fieldItem,
                                    title: getFieldItemTitle(fieldItem, key),
                                    width,
                                    align: "center",
                                    render: render,
                                });
                            });
                            // // 新增刪除按鈕
                            // rtnArr.push({
                            //     key: "action",
                            //     title: "Action",
                            //     slot: "action",
                            //     width: 150,
                            //     align: "center",
                            // });
                            rtnObjKey[key] = rtnArr;
                        });
                    }
                });
                return rtnObjKey;
            });
        },
        dependencyCheck(currentLabel, index, field, value, vm) {
            const groupData = vm.tabData[index].subItems;
            const dependencyRules = {
                DDoSAnalyze: {
                    dependents: ["DDoSAnalyzeSetting"],
                },
                BehaviorAnalyze: {
                    dependents: ["BehaviorAnalyzeSetting"],
                },
                DDoSAnalyzeSetting: {
                    dependents: [],
                    parent: "DDoSAnalyze",
                },
                BehaviorAnalyzeSetting: {
                    dependents: [],
                    parent: "BehaviorAnalyze",
                },
            };

            const rule = dependencyRules[currentLabel];
            
            // 非在 dependencyRules 中不需要檢查
            if (!rule) {
                return
            }

            const currentRow = groupData.find((e) => e.label === currentLabel);
            const labelsToDisable = [];

            // 情境一：不可在 isShow 為 false 的情況下，開啟同橫列的 isEnabled
            if (field === "isEnabled" && value && !currentRow.isShow) {
                labelsToDisable.push(currentLabel);
                vm.$Notice.warning({
                    title: vm.$t("global.reminderText"),
                    desc: vm.$t("backendsTitle.cannotEnableWhenShowIsOff", {
                        field: currentLabel,
                    }),
                });
            }

            // 情境二：若同橫列的 isShow 為 false，且 isEnabled 為 true，連帶關閉後者
            if (field === "isShow" && !value && currentRow.isEnabled) {
                labelsToDisable.push(currentLabel);
                vm.$Notice.warning({
                    title: vm.$t("global.reminderText"),
                    desc: vm.$t("backendsTitle.autoDisableSameRowLabel", { field: currentLabel }),
                });
            }

            // 情境三：若父層的 isShow 為 false，連帶關閉子層的選項
            const enabledDependents = rule.dependents.filter((dependentLabel) => {
                const dependent = groupData.find((e) => e.label === dependentLabel);
                return dependent.isShow;
            });
            if (field === "isShow" && enabledDependents.length > 0) {
                labelsToDisable.push(...enabledDependents);
                vm.$Notice.warning({
                    title: vm.$t("global.reminderText"),
                    desc: vm.$t("backendsTitle.autoDisableCrossRowLabels", { dependent: enabledDependents.join(", ") }),
                });
            }

            // 情境四：若父層的 isShow 為 false，不可開啟子層的 isShow
            const parentRow = groupData.find((e) => e.label === rule.parent);
            if (field === "isShow" && value && rule.parent && !parentRow.isShow) {
                labelsToDisable.push(currentLabel);
                vm.$Notice.warning({
                    title: vm.$t("global.reminderText"),
                    desc: vm.$t("backendsTitle.requiredParentIsShow", { parent: rule.parent }),
                });
            }

            // 沒有需要處理連動的開關
            if (labelsToDisable.length === 0) {
                return;
            }

            // 處理連動更新的開關
            const uniqueLabels = [...new Set(labelsToDisable)];
            vm.$nextTick(() => {
                vm.tabData[index].subItems = vm.tabData[index].subItems.map((e) => {
                    if (uniqueLabels.includes(e.label)) {
                        e.isEnabled = false;
                        e.isShow = false;
                    }
                    return e;
                });
            });
        },
        ok() {
            if (this.isModal) {
                let renObj = {};
                this.data.forEach((e) => {
                    if (this.changeField.includes(e.id)) renObj[e.id] = e.value;
                });

                // 把要異動的群組排除
                renObj["groupScope"] = this.data
                    .find((e) => e.id == "groupScope")
                    .value.filter((e) => !this.changeGroup.includes(e.groupName));

                // let isGlobalScope = this.data.find((e) => e.id == "isGlobalScope").value;
                // if (isGlobalScope) {
                //     // 排除全域設定
                //     renObj["groupScope"] = renObj["groupScope"].filter((e) => e.groupName != "all");
                //     // 加入新的全域設定
                //     renObj["groupScope"].push(this.tabData.find((e) => e.groupName == "all"));
                // }
                // 新增本次修改的群組設定
                this.changeGroup.forEach((groupName) => {
                    let pushGroup = this.tabData.find((e) => e.groupName == groupName);
                    if (pushGroup) renObj["groupScope"].push(pushGroup);
                });

                this.isModal = false;
                this.$emit("changeData", this.title, renObj);
            }
        },
        cancel() {
            this.setTables();
        },
        changeData(item, $event) {
            if (item.id == "isGlobalScope") {
                if ($event) {
                    this.currentTab = "all";
                    this.isTabsDisable = true;
                    this.selectMenu(this.currentTab);
                } else {
                    this.isTabsDisable = false;
                }
            }
            let changeVal = $event;
            if ($event.target) {
                changeVal = $event.target._value;
            }
            this.data = this.data.map((e) => {
                if (e.id == item.id) {
                    e.value = changeVal;
                }
                return e;
            });
            if (!this.changeField.find((e) => e == item.id)) this.changeField.push(item.id);
        },
        selectMenu(groupName) {
            this.currentTab = groupName;
            this.selectTab = this.tabColumns.find((e) => e.groupName == groupName);
        },
        originalSetting(groupName) {
            // 去除data 的群組
            const dataCopy = JSON.parse(JSON.stringify(this.data));
            this.data = dataCopy.map((e) => {
                if (e.id == "groupScope") {
                    e.value = e.value.filter((item) => item.groupName != groupName);
                }
                return e;
            });

            // 把該群組的icon換掉
            this.tabColumns = this.tabColumns.map((e) => {
                if (e.groupName == groupName) {
                    e.icon = "md-close";
                }
                return e;
            });

            // 設定表身改成all
            let allTabData = Object.assign(
                {},
                this.tabData.find((e) => e.groupName == "all")
            );
            delete allTabData.groupName;
            const tabDataCopy = JSON.parse(JSON.stringify(this.tabData));
            this.tabData = tabDataCopy.map((e) => {
                if (e.groupName == groupName) {
                    e = allTabData;
                    e.groupName = groupName;
                }
                return e;
            });
            this.selectMenu(this.currentTab);
        },
        addData(groupName, actionName) {
            const firstOption = Object.assign({}, this.option[this.title][actionName][0]);
            this.tabData = this.tabData.map((item) => {
                if (item.groupName === groupName) {
                    item.dnsProviderList.push(firstOption);
                }
                return item;
            });

            // 換掉正在修改群組的icon
            this.tabColumns = this.tabColumns.map((e) => {
                if (e.groupName == this.currentTab) {
                    e.icon = "md-checkmark-circle-outline";
                }
                return e;
            });
        },
        deleteData(groupName, index) {
            this.$Modal.confirm({
                title: "移除選項",
                content: `您確定要移除表格第${1 + index}列的選項嗎?`,
                okText: "確定",
                onOk: async () => {
                    this.tabData = this.tabData.map((item) => {
                        if (item.groupName === groupName) {
                            item.dnsProviderList = item.dnsProviderList.filter((e, i) => i != index);
                        }
                        return item;
                    });
                },
            });
        },
    },
    mounted() {},
    created() {
        this.setCurrentTab();
        this.setTables();
        this.selectMenu(this.currentTab);
    },
    destroyed() {},
    beforeDestroy() {},
};

let renderSwitch = (key, index, h, params, vm, dependencyCheck = () => {}) => {
    return h("i-switch", {
        props: {
            trueColor: "default",
            value: params.row[params.column.key],
            disabled: params.disabled,
        },
        on: {
            "on-change": (value) => {
                const currentLabel = params.row.label;
                // console.log(
                //     `index:${index}, key:${key}, params.index:${params.index}, params.column.key:${params.column.key},`
                // );
                // 記錄修改的群組
                if (!vm.changeGroup.find((groupName) => groupName == vm.tabData[index].groupName)) {
                    vm.changeGroup.push(vm.tabData[index].groupName);
                }

                // 換掉正在修改群組的icon
                vm.tabColumns = vm.tabColumns.map((e) => {
                    if (e.groupName == vm.currentTab) {
                        e.icon = "md-checkmark-circle-outline";
                    }
                    return e;
                });

                // 依賴判斷(目前智能防護有此判斷 ex: 二重防護/二重防護設定)
                dependencyCheck(currentLabel, index, params.column.key, value, vm);

                if (vm.currentTab == "all") {
                    // all 要把沒有自定義的群組一並更換
                    vm.tabData = vm.tabData.map((item) => {
                        let findGroupTabCol = vm.tabColumns.find((e) => e.groupName == item.groupName);
                        if (item.groupName == vm.currentTab || findGroupTabCol.icon == "md-close") {
                            item[key][params.index][params.column.key] = value;
                        }
                        return item;
                    });
                } else {
                    // 只修改自定義的群組設定
                    vm.tabData[index][key][params.index][params.column.key] = value;
                }

                vm.selectMenu(vm.currentTab);
            },
        },
    });
};

let renderNumberInput = (key, index, h, params, vm) => {
    return h("InputNumber", {
        props: {
            value: params.row[params.column.key],
            min: 1,
            step: 1,
            disabled: params.disabled,
        },
        on: {
            "on-change": (event) => {
                let value = event;
                if (!vm.changeGroup.find((groupName) => groupName == vm.tabData[index].groupName)) {
                    vm.changeGroup.push(vm.tabData[index].groupName);
                }

                // 換掉正在修改群組的icon
                vm.tabColumns = vm.tabColumns.map((e) => {
                    if (e.groupName == vm.currentTab) {
                        e.icon = "md-checkmark-circle-outline";
                    }
                    return e;
                });

                if (vm.currentTab == "all") {
                    // all 要把沒有自定義的群組一並更換
                    vm.tabData = vm.tabData.map((item) => {
                        let findGroupTabCol = vm.tabColumns.find((e) => e.groupName == item.groupName);
                        if (item.groupName == vm.currentTab || findGroupTabCol.icon == "md-close") {
                            item[key][params.index][params.column.key] = value;
                        }
                        return item;
                    });
                } else {
                    // 只修改自定義的群組設定
                    vm.tabData[index][key][params.index][params.column.key] = value;
                }

                vm.selectMenu(vm.currentTab);
            },
        },
    });
};

let renderInput = (key, index, h, params, vm) => {
    return h("Input", {
        props: {
            trueColor: "default",
            value: params.row[params.column.key],
            // disabled: false,
            disabled: params.disabled,
        },
        on: {
            "on-blur": (event) => {
                let value = event.target._value;
                if (!vm.changeGroup.find((groupName) => groupName == vm.tabData[index].groupName)) {
                    vm.changeGroup.push(vm.tabData[index].groupName);
                }

                // 換掉正在修改群組的icon
                vm.tabColumns = vm.tabColumns.map((e) => {
                    if (e.groupName == vm.currentTab) {
                        e.icon = "md-checkmark-circle-outline";
                    }
                    return e;
                });

                if (vm.currentTab == "all") {
                    // all 要把沒有自定義的群組一並更換
                    vm.tabData = vm.tabData.map((item) => {
                        let findGroupTabCol = vm.tabColumns.find((e) => e.groupName == item.groupName);
                        if (item.groupName == vm.currentTab || findGroupTabCol.icon == "md-close") {
                            item[key][params.index][params.column.key] = value;
                        }
                        return item;
                    });
                } else {
                    // 只修改自定義的群組設定
                    vm.tabData[index][key][params.index][params.column.key] = value;
                }

                vm.selectMenu(vm.currentTab);
            },
        },
    });
};

let renderSelect = (key, index, h, params, vm) => {
    const option = vm.option[vm.title][key].map((item) => {
        return {
            label: item.dnsprovider,
            value: item.dnsprovider,
        };
    });

    let parameter = {
        props: {
            value: params.row[params.column.key],
            transfer: true,
            filterable: true,
            multiple: false,
            "allow-create": false,
            disabled: params.disabled,
        },
        on: {
            "on-change": async (value) => {
                // 記錄修改的群組
                if (!vm.changeGroup.find((groupName) => groupName == vm.tabData[index].groupName)) {
                    vm.changeGroup.push(vm.tabData[index].groupName);
                }

                const findOptionValue = vm.option[vm.title][key].find((item) => item.dnsprovider == value);

                // 換掉正在修改群組的icon
                vm.tabColumns = vm.tabColumns.map((e) => {
                    if (e.groupName == vm.currentTab) {
                        e.icon = "md-checkmark-circle-outline";
                    }
                    return e;
                });
                if (vm.currentTab == "all") {
                    // all 要把沒有自定義的群組一並更換
                    vm.tabData = vm.tabData.map((item) => {
                        let findGroupTabCol = vm.tabColumns.find((e) => e.groupName == item.groupName);
                        if (item.groupName == vm.currentTab || findGroupTabCol.icon == "md-close") {
                            // item[key][params.index] = vm.option[vm.title][key].find(
                            //     (item) => item.dnsprovider == value
                            // );
                            item[key][params.index]["accessKeyId"] = findOptionValue["accessKeyId"];
                            item[key][params.index]["defaultRecordLine"] = findOptionValue["defaultRecordLine"];
                            item[key][params.index]["dnsRootDomain"] = findOptionValue["dnsRootDomain"];
                            item[key][params.index]["dnsprovider"] = findOptionValue["dnsprovider"];
                            item[key][params.index]["isEnabled"] = findOptionValue["isEnabled"];
                            item[key][params.index]["minTtl"] = findOptionValue["minTtl"];
                            item[key][params.index]["secretAccessKey"] = findOptionValue["secretAccessKey"];
                        }
                        return item;
                    });
                } else {
                    // 只修改自定義的群組設定
                    // vm.tabData[index][key][params.index] = vm.option[vm.title][key].find(
                    //     (item) => item.dnsprovider == value
                    // );
                    // vm.tabData[index][key][params.index][params.column.key] = value;
                    vm.tabData[index][key][params.index]["accessKeyId"] = findOptionValue["accessKeyId"];
                    vm.tabData[index][key][params.index]["defaultRecordLine"] = findOptionValue["defaultRecordLine"];
                    vm.tabData[index][key][params.index]["dnsRootDomain"] = findOptionValue["dnsRootDomain"];
                    vm.tabData[index][key][params.index]["dnsprovider"] = findOptionValue["dnsprovider"];
                    vm.tabData[index][key][params.index]["isEnabled"] = findOptionValue["isEnabled"];
                    vm.tabData[index][key][params.index]["minTtl"] = findOptionValue["minTtl"];
                    vm.tabData[index][key][params.index]["secretAccessKey"] = findOptionValue["secretAccessKey"];
                }
            },
        },
    };

    return h(
        "i-select",
        parameter,
        option.map((item) => {
            return h("Option", {
                props: {
                    value: item.value || item,
                    label: item.label || item,
                },
            });
        })
    );
};
</script>



// WEBPACK FOOTER //
// src/components/rcmTableFormItems/MenuModel.vue